(function () {
  'use strict';

  angular
    .module('boxPreview')
    .directive('mfBoxpreview', boxPreview);

  boxPreview.$inject = [];
  boxPreviewController.$inject = ['$scope'];

  function boxPreviewController($scope) {
    var vm = this;
    vm.$onInit = onInit;
    var preview = null;

    function onInit() {
      preview = new Box.Preview();

      var options = {
        container: '.box-preview-container',
        header: 'none',
        proxyUrl: '/gaviota-api/box'
      };

      if (vm.pageRange.length === 1) {
        options.viewers = {
          Document: {
            disabled: true
          },
          SinglePage: {
            pageRange: vm.pageRange[0].index + 1
          }
        };
      }

      preview.show(vm.boxId,  mfConfig.box.apiToken, options);

      preview.once('load', function(data) {
        // var viewer = data.viewer;
        // viewer.setPage(1);
      });
    }

    $scope.$on('$destroy', function () {
      if (preview) {
        preview.destroy();
      }
    });
  }

  function boxPreview() {
    var directive = {
      scope: {
        boxId: '<',
        pageRange: '<'
      },
      controller: boxPreviewController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;
  }
})();
